<template>
  <div class="orders-list-table Is">
    <el-table :data="dataList" :header-cell-style="{ background: '#fafafa', color: '#333333' }">
      <template v-for="{ type, prop, label, width, slot, align, fixed } in config">
        <el-table-column :key="prop" :prop="prop" :label="label" :min-width="width" :fixed="fixed" :align="align"
          v-if="slot">
          <template slot-scope="scope">
            <template v-if="slot === 'goods'">
              <!-- z-index 递减 上层 覆盖 下层 -->
              <div class="itemN" :style="{ zIndex: 100 - scope.$index }" v-if="scope.row.orderAfterDetail">
                <div class="order_details" style="padding-top: 8px">
                  <div class="order_details_box">
                    <div class="order_details_item">
                      <span class="order_details_title">售后状态</span><span style="margin-left: 8px">{{
                        scope.row.orderAfterDetail.orderAfterStatusLabel
                      }}</span>
                    </div>
                  </div>
                  <div class="blankBox"></div>
                  <div class="order_details_box">
                    <div class="order_details_item" style="display: flex">
                      <div class="order_details_title" style="margin-top: 20px">
                        售后编号
                      </div>
                      <div style="margin-left: 8px">
                        {{ scope.row.orderAfterDetail.orderAfterNo }}
                      </div>
                      <div @click="copy(scope.row.orderAfterDetail.orderAfterNo)"
                        style="margin-left: 8px; cursor: pointer">
                        <img src="../../../assets/icon_fuzhi.png" style="width: 16px; height: 16px; padding-top: 12px" />
                      </div>
                      <div @click="copy(scope.row.orderAfterDetail.orderAfterNo)" style="
                          margin-left: 8px;
                          color: #2d46ee;
                          cursor: pointer;
                        ">
                        复制
                      </div>
                    </div>
                  </div>
                  <div class="blankBox"></div>
                  <div class="order_details_box">
                    <div class="order_details_item">
                      <span class="order_details_title">售后说明</span><span style="margin-left: 8px">{{
                        scope.row.orderAfterDetail.afterRemark
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="order_details">
                  <div class="order_details_box">
                    <div class="order_details_item">
                      <span class="order_details_title">审核时间</span><span style="margin-left: 8px">{{
                        scope.row.orderAfterDetail.approveTime
                      }}</span>
                    </div>
                  </div>
                  <div class="blankBox"></div>
                  <div class="order_details_box" v-if="scope.row.orderAfterDetail.orderAfterStatusLabel ==
                      '退货退款中' ||
                      scope.row.orderAfterDetail.orderAfterStatusLabel ==
                      '退货退款已完成'
                      ">
                    <div class="order_details_item">
                      <span class="order_details_title">退回金额</span><span style="margin-left: 8px">{{
                        Number(scope.row.orderAfterDetail.refundMoney).toFixed(
                          2
                        )
                      }}</span>
                    </div>
                  </div>
                  <div class="order_details_box" v-if="scope.row.orderAfterDetail.orderAfterStatus == 2">
                    <div class="order_details_item">
                      <span class="order_details_title">驳回备注</span><span style="margin-left: 8px">{{
                        scope.row.orderAfterDetail.approveRemark
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div :style="{
                    'padding-bottom': scope.row.orderAfterDetail
                      ? '120px'
                      : '10px',
                  }">
                <div style="text-align: left">{{ scope.row.goodsName }}</div>
                <div style="text-align: left">
                  规格:{{ scope.row.goodsSkuName }}
                </div>
                <div style="text-align: left">
                  商品编号:{{ scope.row.goodsNo }}
                </div>
              </div>
            </template>
            <template v-if="slot === 'retailPrice'">
              <div :style="{
                'padding-bottom': scope.row.orderAfterDetail
                  ? '120px'
                  : '10px',
              }">
                <div>￥{{ Number(scope.row.retailPrice).toFixed(2) }}</div>
                <div>x{{ scope.row.goodsQuantity }}</div>
              </div>
            </template>
            <template v-if="slot === 'freightAmount'">
              <div :style="{
                'padding-bottom': scope.row.orderAfterDetail
                  ? '120px'
                  : '10px',
              }">
                ￥{{ Number(scope.row.freightAmount).toFixed(2) }}
              </div>
            </template>
            <template v-if="slot === 'discountAmount'">
              <div :style="{
                'padding-bottom': scope.row.orderAfterDetail
                  ? '120px'
                  : '10px',
              }">
                ￥{{ Number(scope.row.discountAmount).toFixed(2) }}
              </div>
            </template>

            <template v-if="slot === 'totalAmount'">
              <div :style="{
                'padding-bottom': scope.row.orderAfterDetail
                  ? '120px'
                  : '10px',
              }">
                实付￥{{ Number(scope.row.totalAmount).toFixed(2) }}
              </div>
            </template>
            <template v-if="slot === 'preferential'">
              <div :style="{
                'padding-bottom': scope.row.orderAfterDetail
                  ? '120px'
                  : '10px',
              }">
                ￥0.00
              </div>
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'OrdersListTable',
  props: {
    afterSale: {
      type: String,
      default: () => ''
    },
    typeStr: {
      type: String,
      default: () => ''
    },
    type: {
      type: String,
      default: () => ' '
    },
    heightStr: {
      type: String,
      default: () => '500px'
    },
    sortObj: { // 排序
      type: Object,
      default: () => {
      }
    },
    config: {
      type: Array,
      default: () => []
    },
    dataList: { // 数据列表
      type: Array,
      default: () => []
    },
    parArrayArr: { // 按钮权限
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      radio: 3,
      isApply: false,
      userInfo: {},
      operationActiveIndex: '1',
      popSty: false,
      isShowCom: {}, // 操作 按钮 组件显示 默认 全为 false
      isShowTime: {
        closedTime: false, // 关闭时间
        createdTime: false, // 下单时间
        finishedTime: false, // 审核时间
        submitDate: false // 提交审核时间
      },
      routeObj: {}
    }
  },
  watch: {
    config: {
      handler(newVal, oldVal) {
        console.log(newVal)
      },
      deep: true
    },
    dataList: {
      handler(newVal, oldVal) {
        // console.log(newVal)
        setTimeout(_ => {
          // this.resetStyle() // 样式调整
        }, 100)
      },
      deep: true
    },
    typeStr(value) {
      // console.log(value)
      this.showCom() // 操作 按钮 组件显示
    },
    // afterSale: {
    //   handler (newVal, oldVal) {
    //     console.log(newVal)
    //   }
    // },
    $route() {
      // this.testFun();
    }
  },
  mounted() {
    // console.log(this.dictionaries.after_sale_reason)
    this.$nextTick(_ => {
      // this.resetDate()
      // this.resetStyle()
      console.log('afterSale==', this.afterSale)
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      this.onShowTime()
    })
  },
  created() {
    this.routeObj = this.$route
  },
  methods: {
    copy(val) {
      const t = this
      this.$copyText(val).then(
        function (e) {
          t.$message({
            type: 'success',
            message: '复制成功'
          })
        },
        function (e) {
          t.$message({
            type: 'warning',
            message: '复制失败'
          })
        }
      )
    },
    apply() {
      this.isApply = true
    },
    onShowTime() {
      const routeName = this.$route.name
      switch (routeName) {
        case 'ordersList': // 客服订单
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'examinationOrderList': // 审核订单
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'afterSaleOrdeList': // 售后订单
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'afterSaleRecordList': // 售后记录
          break
        default:
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.finishedTime = true // 审核时间
        // console.log('%c默认值！👀', 'color:#fff;font-size:1.2rem;padding:0.8rem 1.6rem;border-radius: 5px;background-color: #3eaf7c;font-family: "Microsoft YaHei",Arial,sans-serif;')
      }
      console.log(routeName, this.isShowTime)
    },
    resetStyle() {
      this.$nextTick(_ => {
        // 获取 所有行
        const elTableRowFirst = document.getElementsByClassName('el-table__row')
        elTableRowFirst.forEach((item, index) => {
          if (index === 0) {
            console.log(item)
            // 获取  第一行的第二个
            // return console.log(item)
            const elTableCell = item.getElementsByClassName('el-table__cell')[1]
            const elTableCell5 = item.getElementsByClassName('el-table__cell')[5]
            const elTableCelldivCell = elTableCell5.getElementsByClassName('cell')[0]

            const relationOrder = elTableCell.getElementsByClassName('relation-order')[0]
            if (!relationOrder) {
              elTableCell.style.paddingTop = '45px'
              elTableCelldivCell.setAttribute('style', '')
              // console.log('没找到关联订单调整 ppadding-top')
            } else {
              elTableCell.setAttribute('style', '')
              elTableCelldivCell.style.marginTop = '30px'
            }
          } else {
            // 获取  其它行的第二个
            // return console.log(item)
            const elTableCell = item.getElementsByClassName('el-table__cell')[1]
            const relationOrder = elTableCell.getElementsByClassName('relation-order')[0]
            const mesSty = elTableCell.getElementsByClassName('mesSty')[0]
            if (relationOrder) {

            } else {
              mesSty.setAttribute('style', '')
            }
          }
        })
      })
    },
    // 页面跳转
    toOtherPages(name, parameter, type) {
      // console.log(name, parameter, type)
      // console.log(parameter)
      // return
      let query = {}
      query = { orderNo: parameter.orderNo, orderId: parameter.orderId, id: parameter.orderId }
      this.$router.push({ name, query })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },


    onSelectionChange(val) { // 多选
      // this.multipleSelection = val;
      // console.log(val)
      this.$emit('tableSelectionChange', val)
    }
  }
}
</script>
<!--<style scoped>-->
<style lang="scss" scoped>
.order_details {
  width: 100%;
  display: flex;
  justify-content: left;
  flex-wrap: nowrap;

  // margin-top: 15px;
  .blankBox {
    width: 20px;
  }

  .order_details_item {
    // min-width: 255px;
    line-height: 40px;

    .order_details_title {
      width: auto;
      font-size: 14px;
      font-weight: 400;
      line-height: 0px;
      color: #999999;
      text-align: left;
      display: inline-block;
    }

    .order_details_value {
      font-size: 14px;
      font-weight: 400;
      line-height: 0px;
      color: #666666;
      padding-left: 12px;
    }
  }
}

.pass {
  width: 414px;
  height: 36px;
  background: #e9ecfe;
  opacity: 1;
  border-radius: 2px;
  line-height: 36px;
  padding-left: 12px;
  margin-top: 24px;
  margin-bottom: 100px;

  .price {
    color: #f63c56;
  }
}

::v-deep .el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;

  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }

  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}

::v-deep .el-dialog__header {
  text-align: left;
  border-bottom: none;
}

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #303033;
  opacity: 1;
  text-align: left;
}

.info-b {
  margin-left: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #303033;
  text-align: left;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.tooltip {
  position: relative;
  /*margin: 50px auto;*/
  /*border: 1px solid;*/
  cursor: pointer;
}

.tooltip[aria-label]:hover:after {
  content: attr(aria-label);
  position: absolute;
  bottom: -38px;
  left: 30%;
  /*border: 1px solid;*/
  width: 80px;
  text-align: center;
  border-radius: 3px;
  padding: 5px;
  color: #ffffff;
  font-size: 12px !important;
  background-color: rgba(0, 0, 0, 0.5);
}

.mesSty:after {
  clear: both;
  display: table;
  content: "";
}

/*圆点*/
.round {
  width: 10px;
  height: 10px;
  border-radius: 50px;
  background-color: #0b7df3;
  display: inline-block;
}

.primary-bg {
  background-color: #409eff !important;
}

.success-bg {
  background-color: #12ab62 !important;
}

.warning-bg {
  background-color: #e6a23c !important;
}

.danger-bg {
  background-color: #f56c6c !important;
}

.info-bg {
  background-color: #909399 !important;
}

.el-table {
  overflow: unset;
}

::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
  background-color: #ffffff;
}

::v-deep.el-table th.el-table__cell {
  background-color: #f8f8f8;
}

::v-deep.el-table th.el-table__cell .cell {
  color: #333333;
  font-size: 16px;
}

::v-deep .el-table tr {
  position: relative;
  width: 100%;
}

::v-deep.el-table .el-table__body .el-table__row {
  position: relative !important;
}

::v-deep.el-table .el-table__body .el-table__row:first-child td:first-child .cell {
  top: 8px;
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell:nth-child(1) {
  position: static !important;
  /*padding: 5px 0;*/
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row {
  position: relative !important;
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell {
  // background-color: #0b7df3;
  padding-bottom: 0px;
  /*padding-bottom: 15px;*/
}

.itemN {
  width: 100%;
  height: auto;
  line-height: 40px;
  // display: flex;
  // justify-content: space-between;
  background-color: #f5f6fa;
  position: absolute;
  bottom: 0;
  left: 0;
  padding-left: 14px;
  padding-bottom: 14px;
}

::v-deep.el-table .el-table__body .el-table__row:first-child td:nth-child(2) .item {
  top: 0;
  /*background-color: rgba(0,0,0,0.3);*/
}

@media (min-width: 1500px) {}

@media screen and (max-width: 1500px) {
  .item div:first-child label:first-child {
    font-size: 14px;
    color: #4168e7;
    line-height: 20px;
    display: block;
  }

  .item {
    width: 100%;
    height: 40px;
    background-color: #ebeef5;
    padding: 0px 0 7px 50px;
    position: absolute;
    /*top: 0;*/
    left: 0;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
  }
}

@media screen and (max-width: 1200px) {
  ::v-deep.el-table .el-table__body .el-table__row td:first-child .cell {
    /*top: -25px;*/
  }
}

@media (min-width: 768px) {}

.afterSaleAmount {
  margin-top: 40px;
}

.afterSaleStatus {
  margin-top: 50px;
}
</style>
